import {
  faMagnifyingGlass,
  faArrowUpRightFromSquare,
  faCircleXmark,
  faPenToSquare,
  faArrowLeft,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState, useMemo } from "react";
import { useDispatch } from "react-redux";
import { logout } from "../../features/userSlice";
import { useContextStateManagement } from "../../context/ContextApi";
import { ChatGGrid } from "../../child-components/InboundFlow/ChatGGrid";
import { LeadGGrid } from "../../child-components/InboundFlow/LeadGGrid";
import { GeneralCallSetting } from "../../callSettings/GeneralCallSetting";
import { TimeZoneDropdown } from "../../onBoardingTemplateForms/TimeZoneDropdown";
import InfoTooltip from "../common/InfoTooltip";
import { BulkUploadLead } from "../../bulk-upload-lead/BulkUploadLead";
import { PAuthQOnBoardingForm } from "../../onBoardingTemplateForms/PAuthQOnBoardingForm";
import { ChatGOnBoardingForm } from "../../onBoardingTemplateForms/ChatGOnBoardingForm";
import { LeadGenerationOnboardingForm } from "../../onBoardingTemplateForms/LeadGenerationOnboardingForm";
import TabPointer_icon from "../../assets/images/TabPointer_icon.png";
import { UAT_Test } from "../../child-components/InboundFlow/UAT_Test";
import InBoundCalls from "../../child-components/InboundFlow/InBoundCalls";
import { getUserLicenseDetails } from "../../Variables";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { ApiIntegration } from "../../apiFunctions/ApiIntegration";
import { InboundCallLogs } from "../../child-components/InboundFlow/InboundCallLogs";
import { InboundCallSummary } from "../../child-components/InboundCallSummary/InboundCallSummary";
import { AddUsersToOrg } from "../ManageOrg/AddUsersToOrg";
import { ManageOrg } from "../ManageOrg/ManageOrg";
import { PhoneNum } from "../PhoneSettings/PhoneNum";
import DialerPage from "../../child-components/dialer/DialerPage";
import { ManageLeadsPage } from "../../manage-leads/ManageLeadsPage";
import { enrichInboundCallRows } from "../../inboundCallHelpers";
import SupportPage from "../../pages/SupportPage/SupportPage";
import TicketsPage from "../../pages/TicketsPage/TicketsPage";
import InboundOverview from "../../child-components/InboundFlow/InboundOverview";
import OutboundOverview from "../../child-components/InboundFlow/OutboundOverview";
import DateRangePicker from "./DateRangePicker";
import SummaryPromptHub from "./SummaryPromptHub";
import { useConsoleSearch } from "./hooks/useConsoleSearch";
import { useAccessRights } from "./hooks/useAccessRights";
import { useMfaRefresh } from "./hooks/useMfaRefresh";
import { usePracticeSwitcher } from "./hooks/usePracticeSwitcher";
import { useUserMenu } from "./hooks/useUserMenu";
import "./Home.css";

export const Home = ({
  setIsUploadLead,
  isUploadLead,
  setIsTabClick,
  setCurrentRoute,
  setUserDataAccess,
  outBoundLeadsDetail,
  setOutBoundLeadsDetail,
}) => {
  const {
    memberListName,
    setMemberListName,
    activeTab,
    setActiveTab,
    sideBarLinkActive,
    setToken,
    practiceContactNumber,
    userName,
    setPracticeId,
    userProfession,
    accessRights,
    PracticeId,
    setSideBarLinkActive,
    dateRangeRequest,
    token,
    outBoundContact,
    setOutBoundContact,
    inboundContact,
    setInboundContact,
    userEmail,
    setActiveOnBoardingTem,
    setActiveUploadLead,
    setDateUrl,
    setPracticesList,
    setUserName,
    setUserProfession,
    practicesList,
    practiceUsername,
    setPracticeUsername,
    setPracticeContactNumber,
    setUserType,
    userType,
    userAdmin,
    setCurrentUserId,
    currentUserId,
    usersPostRequest,
    liscenseType,
    setLiscenseType,
    fetchPracticesList,
    setPracticeName,
    practiceName,
    setPracticeCreateDate,
    fetchApiHandle,
    deleteRequest,
    rightsEnabled,
    setRightsEnabled,
    onBoardingRightsId,
    setOnBoardingRightsId,
    isRightsLoad,
    setIsRightsLoad,
    registerPhoneTabSetter,
    hasPageAccess,
    orgPageAccessConfigured,
    patchRequest,
    ownPracticeId,
    ownPracticeName,
    setOwnPracticeName,
    clearSelectedOrg,
    setCredentialsSaved,
    bumpTimezonePreferenceVersion,
  } = useContextStateManagement();
  const [showOnboarding, setShowOnboarding] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [showLogButton, setShowLogButton] = useState(false);
  const {
    providerName,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    hasExplicitDateRange,
    setHasExplicitDateRange,
    patientName,
  } = useConsoleSearch();
  const [isTokenExpired, setIsTokenExpired] = useState(false);

  const { fetchAccessRights } = useAccessRights({
    token,
    PracticeId,
    onBoardingRightsId,
    dateRangeRequest,
    setIsRightsLoad,
    setIsTokenExpired,
    setRightsEnabled,
  });

  const { handleMFARefresh } = useMfaRefresh({
    token,
    currentUserId,
    usersPostRequest,
    setIsTokenExpired,
  });

  const {
    orgMenuRef,
    isOrgMenuOpen,
    setIsOrgMenuOpen,
    showOrganizationModal,
    setShowOrganizationModal,
    organizationDraftName,
    setOrganizationDraftName,
    organizationUpdateError,
    isSavingOrganizationName,
    openOrganizationModal,
    handleOrganizationRename,
    handlePracticeSelect,
    filteredSelectablePractices,
    orgSearchQuery,
    setOrgSearchQuery,
    selectedPracticeLabel,
  } = usePracticeSwitcher({
    practicesList,
    PracticeId,
    ownPracticeId,
    ownPracticeName,
    practiceName,
    token,
    userType,
    patchRequest,
    fetchPracticesList,
    setPracticeId,
    setPracticeContactNumber,
    setOutBoundContact,
    setInboundContact,
    setPracticeName,
    setPracticeCreateDate,
    setCredentialsSaved,
    setOwnPracticeName,
    setPracticesList,
  });

  const [isBulkUploaded, setIsBulkUploaded] = useState(false);
  const [inBoundsCalls, setInBoundsCalls] = useState([]);
  const [leadGGridData, setLeadGGridData] = useState([]);
  const [chatGGridData, setChatGGridData] = useState([]);
  const [uatTestGridData, setUatTestGridData] = useState([]);
  const [inboundCallLogsData, setInboundCallLogsData] = useState([]);
  const [isCallsDataGet, setIsCallsDataGet] = useState(false);
  const [isDatesEmpty, setIsDatesEmpty] = useState(false);
  const [isDataGetWithDate, setIsDataGetWithDate] = useState(false);
  const [isDataGetWithDateInbound, setIsDataGetWithDateInbound] =
    useState(false);
  const [isPhoneTab, setIsPhoneTab] = useState(false);
  const [preferredTimezone, setPreferredTimezone] = useState("");
  const [timezoneSyncMode, setTimezoneSyncMode] = useState("auto");
  const [savingPreferredTimezone, setSavingPreferredTimezone] = useState(false);
  const [preferredTimezoneSavedMessage, setPreferredTimezoneSavedMessage] = useState("");
  const [activeSettingsSection, setActiveSettingsSection] = useState("profile");
  const {
    isUserMenuOpen,
    setIsUserMenuOpen,
    userMenuRef,
    isSettingsModalOpen,
    openSettingsPanel,
    closeSettingsPanel,
  } = useUserMenu();

  useEffect(() => {
    if (!isSettingsModalOpen || !token) return;
    let cancelled = false;
    (async () => {
      const data = await dateRangeRequest(token, "/api/getPreferredTimezone", {});
      if (!cancelled && data && typeof data === "object") {
        setPreferredTimezone(data.PreferredTimezone || "");
        setTimezoneSyncMode(data.TimezoneSyncMode || "auto");
      }
    })();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSettingsModalOpen, token]);

  // Picking a zone or a sync mode only updates the on-screen draft now - nothing is sent to
  // the server until the user clicks Save (handleSaveTimezone below). Previously this saved on
  // every change, but other already-open pages (Dashboard, Inbound/Outbound graphs) each keep
  // their own separate copy of the timezone fetched once at load, so the change never reached
  // them without a manual reload - Save now also bumps a shared version (see
  // bumpTimezonePreferenceVersion) those pages watch, so they refetch and pick it up live.
  const handlePreferredTimezoneChange = (event) => {
    setPreferredTimezone(event.target.value);
    setPreferredTimezoneSavedMessage("");
  };

  // Switching TO "auto" previews the browser's current zone right away (so the dropdown
  // reflects it immediately) but still waits for Save to actually persist it. Switching TO
  // "fixed" just leaves whatever zone is currently selected as the draft.
  const handleTimezoneSyncModeChange = (mode) => {
    setTimezoneSyncMode(mode);
    setPreferredTimezoneSavedMessage("");
    if (mode === "auto") {
      const detected = Intl.DateTimeFormat().resolvedOptions().timeZone;
      setPreferredTimezone(detected || "");
    }
  };

  const handleSaveTimezone = async () => {
    setSavingPreferredTimezone(true);
    setPreferredTimezoneSavedMessage("");
    try {
      await patchRequest(token, "/api/updatePreferredTimezone", {
        PreferredTimezone: preferredTimezone || null,
        TimezoneSyncMode: timezoneSyncMode,
      });
      setPreferredTimezoneSavedMessage("Saved");
      bumpTimezonePreferenceVersion();
    } finally {
      setSavingPreferredTimezone(false);
    }
  };
  const [dateRangeApiUrl, setDateRangeApiUrl] = useState(
    "/api/SearchWithDatePAuthQ"
  );
  const [inBoundFilterNonce, setInBoundFilterNonce] = useState(0);
  const [leadGFilterNonce, setLeadGFilterNonce] = useState(0);
  const userBadgeInitial = useMemo(() => {
    const avatarSource = `${currentUserId || userName || userEmail || ""}`.trim();
    return avatarSource ? avatarSource.charAt(0).toUpperCase() : "U";
  }, [currentUserId, userEmail, userName]);
  const canUseDateInputs = !(
    startDate === "" &&
    endDate === "" &&
    isCallsDataGet === false &&
    sideBarLinkActive === "careConsole"
  );

  const buildDateRangeParams = (
    nextStartDate,
    nextEndDate,
    selectedTab = activeTab,
  ) => {
    if (selectedTab === "uatTab") {
      return {
        startDate: nextStartDate,
        endDate: nextEndDate,
        fromContact: outBoundContact,
      };
    }

    if (selectedTab === "inboundLogsTab") {
      return {
        startDate: nextStartDate,
        endDate: nextEndDate,
        inboundContact: inboundContact,
      };
    }

    return {
      startDate: nextStartDate,
      endDate: nextEndDate,
      PracticeId: PracticeId,
      fromContact: outBoundContact,
      inboundContact: inboundContact,
    };
  };

  const canViewTickets = hasPageAccess("tickets", false);

  // logout handle
  const tokenExpiryLogoutHandle = () => {
    setActiveTab("inBoundCalls");
    setIsTabClick(true);
    setSideBarLinkActive("careConsole");
    clearSelectedOrg();
    setUserDataAccess([]);
    setUserType("client");
    setCurrentRoute("login");
    dispatch(logout());
  };

  useMemo(() => {
    if (PracticeId) {
      getUserLicenseDetails(
        usersPostRequest,
        token,
        PracticeId,
        setIsTokenExpired,
        setOutBoundLeadsDetail
      );
    }
  }, [PracticeId]);

  useEffect(() => {
    // Gate on PracticeId so this doesn't fire against userType's transient
    // "client" default before /api/currentUser resolves - otherwise it wipes
    // out a real admin's section before their actual role has even loaded.
    if (
      PracticeId &&
      userType !== "admin" &&
      (
        ["addUsers", "manageOrg", "adminDashboard"].includes(sideBarLinkActive) ||
        (sideBarLinkActive === "voiceOps" && !hasPageAccess("voiceOps", false)) ||
        (sideBarLinkActive === "tickets" && !canViewTickets) ||
        (sideBarLinkActive === "bulkUpload" && !hasPageAccess("bulkUpload", true))
      )
    ) {
      setSideBarLinkActive("careConsole");
      navigate("/", { replace: true });
    }
  }, [
    PracticeId,
    canViewTickets,
    hasPageAccess,
    navigate,
    setSideBarLinkActive,
    sideBarLinkActive,
    userType,
  ]);

  useEffect(() => {
    const tab = new URLSearchParams(location.search).get("tab");

    if (tab === "inbound" && activeTab !== "inBoundCalls") {
      showHideSelectedTabControls("inBoundCalls");
    } else if (tab === "outbound" && activeTab !== "leadGTab") {
      showHideSelectedTabControls("leadGTab");
    } else if (tab === "summary" && activeTab !== "summaryTab") {
      showHideSelectedTabControls("summaryTab");
    }
  }, [activeTab, location.search]);

  // Every sidebar section now has a real URL, so a refresh (or a bookmark,
  // or the back/forward buttons) always lands back on the exact page the
  // user was on instead of resetting to the default Inbound/careConsole view.
  useEffect(() => {
    const path = location.pathname;

    if (path.startsWith("/prompt-hub/")) {
      const workflow = path.slice("/prompt-hub/".length);

      if (workflow === "summary") {
        setSideBarLinkActive("summaryPromptHub");
        return;
      }

      const workflowTabMap = {
        inbound: "inBoundCalls",
        outbound: "leadGTab",
        chatg: "chatG",
      };
      if (workflowTabMap[workflow]) {
        setSideBarLinkActive("onBoardingForm");
        setActiveTab(workflowTabMap[workflow]);
      }
      return;
    }

    if (path === "/inbound") {
      setSideBarLinkActive("careConsole");
      showHideSelectedTabControls("inBoundCalls");
      return;
    }
    if (path === "/outbound") {
      setSideBarLinkActive("careConsole");
      showHideSelectedTabControls("leadGTab");
      return;
    }
    if (path === "/summary") {
      setSideBarLinkActive("careConsole");
      showHideSelectedTabControls("summaryTab");
      return;
    }

    const sidebarOnlyRouteMap = {
      "/call-settings": "callSettings",
      "/bulk-upload": "bulkUpload",
      "/api-integration": "apiIntegration",
      "/add-users": "addUsers",
      "/admin-center": "manageOrg",
    };

    if (sidebarOnlyRouteMap[path]) {
      setSideBarLinkActive(sidebarOnlyRouteMap[path]);
    }
  }, [location.pathname]);

  const isPWADialer = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

  // Auto-open dialer when launched from PWA shortcut (?pwa=dialer)
  useEffect(() => {
    if (isPWADialer) {
      setSideBarLinkActive('dialer');
    }
  }, [isPWADialer, setSideBarLinkActive]);

  function showHideSelectedTabControls(selectedTabId) {
    // debugger
    // if (selectedTabId === "pAuthQTab") {
    //   setActiveTab("pAuthQTab");
    //   setMemberListName("Prior Auth Qualification");
    //   setDateRangeApiUrl("/api/SearchWithDatePAuthQ");
    //   setIsTabClick(false);
    //   setActiveOnBoardingTem(`/api/PAuthQOnBoardingTemplate/${PracticeId}`);
    //   setActiveUploadLead(`/api/PriorAuthQLead/${PracticeId}`);
    // }
    if (selectedTabId === "inBoundCalls") {
      if (sideBarLinkActive === "bulkUpload") {
        setSideBarLinkActive("careConsole");
      }
      // if (sideBarLinkActive === "onBoardingForm" && userType === "client" && rightsEnabled === false) {
      //   setSideBarLinkActive("careConsole")
      // }
      // if ((userType === "admin") || (userType === "client" && rightsEnabled === true)) {
      //   setShowOnboarding(true);
      // } else if (userType === "client" && rightsEnabled === true) {
      //   setShowOnboarding(false);
      //   setSideBarLinkActive("careConsole");
      // }
      setActiveTab("inBoundCalls");
      setMemberListName("Inbound Calls");
      setDateRangeApiUrl("/api/SearchWithDatePAuthQ");
      setIsTabClick(true);
      setActiveOnBoardingTem(`/api/PAuthQOnBoardingTemplate/${PracticeId}`);
      setActiveUploadLead(`/api/PriorAuthQLead`);
      setOnBoardingRightsId(1);
      fetchAccessRights(1, token, PracticeId);
    } else if (selectedTabId === "chatG") {
      if (sideBarLinkActive === "bulkUpload") {
        setSideBarLinkActive("careConsole");
      }
      setActiveTab("chatG");
      setMemberListName("Chatbot Lead Generation");
      setDateRangeApiUrl("/api/SearchWithDateChatbotG");
      setIsTabClick(true);
      setActiveOnBoardingTem(`/api/ChatbotOnboarding/${PracticeId}`);
      setActiveUploadLead(`/api/ChatbotLeadGeneration`);
      setOnBoardingRightsId(8);
      fetchAccessRights(8, token, PracticeId);
    } else if (selectedTabId === "leadGTab") {
      fetchApiHandle("", "leadGTab");
      setActiveTab("leadGTab");
      setMemberListName("Lead Generation");
      setDateRangeApiUrl("/api/SearchWithDateLeadGeneration");
      setIsTabClick(false);
      setActiveOnBoardingTem(`/api/LeadGenerationOnboarding/${PracticeId}`);
      setActiveUploadLead(`/api/getLeadGenerationUploadLead`);
      setOnBoardingRightsId(6);
      fetchAccessRights(6, token, PracticeId);
    } else if (selectedTabId === "uatTab") {
      if (sideBarLinkActive !== "careConsole") {
        setSideBarLinkActive("careConsole");
      }
      setActiveTab("uatTab");
      setMemberListName("Outbound Logs");
      setDateRangeApiUrl("/api/SearchDateUatTest");
      setIsTabClick(true);
      setDateUrl(`/api/SearchDateUatTest`);
      setOnBoardingRightsId(null);
    } else if (selectedTabId === "inboundLogsTab") {
      if (sideBarLinkActive !== "careConsole") {
        setSideBarLinkActive("careConsole");
      }
      setActiveTab("inboundLogsTab");
      setMemberListName("Inbound Call Logs");
      setDateRangeApiUrl("/api/SearchDateInboundCallLogs");
      setIsTabClick(true);
      setDateUrl(`/api/SearchDateInboundCallLogs`);
      setOnBoardingRightsId(null);
    } else if (selectedTabId === "smsTab") {
      setActiveTab("smsTab");
      setMemberListName("SMS");
      setDateRangeApiUrl("/api/getSmsGridData");
      setIsTabClick(true);
      setOnBoardingRightsId(null);
    } else if (selectedTabId === "summaryTab") {
      setActiveTab("summaryTab");
      setMemberListName("Summary");
      setIsTabClick(true);
      setOnBoardingRightsId(null);
    }
    // else if (selectedTabId === "surveyTab") {
    //   setActiveTab("surveyTab");
    //   setMemberListName("Survey");
    //   setSideBarLinkActive("careConsole");
    //   setIsTabClick(true);
    // }
  }

  async function handleStartDateChange(
    requestParams = buildDateRangeParams(startDate, endDate),
  ) {
    // setPriorAuthQGridData([]);
    setInBoundsCalls([]);
    setChatGGridData([]);
    setLeadGGridData([]);
    setUatTestGridData([]);
    setInboundCallLogsData([]);
    setIsDataGetWithDate(false);
    setIsDataGetWithDateInbound(false);

    const userData = await dateRangeRequest(
      token,
      dateRangeApiUrl,
      requestParams
    );
    if (userData == "Token is expired, login again") {
      setIsTokenExpired(true);
    } else if (userData == "no record") {
      // setPriorAuthQGridData([]);
      setInBoundsCalls([]);
      setUatTestGridData([]);
      setChatGGridData([]);
      setLeadGGridData([]);
      setInboundCallLogsData([]);
      setIsDataGetWithDate(true);
      setIsDataGetWithDateInbound(true);
    } else {
      // if (activeTab === "pAuthQTab") {
      //   setPriorAuthQGridData(userData);
      // }
      if (activeTab === "inBoundCalls") {
        setInBoundsCalls(enrichInboundCallRows(userData));
      } else if (activeTab === "chatG") {
        setChatGGridData(userData);
      } else if (activeTab === "leadGTab") {
        setLeadGGridData(userData);
      } else if (activeTab === "uatTab") {
        setUatTestGridData(userData);
        setIsDataGetWithDate(true);
      } else if (activeTab === "inboundLogsTab") {
        setInboundCallLogsData(userData);
        setIsDataGetWithDateInbound(true);
      }
    }
  }

  const toggleShowLogButton = () => {
    setShowLogButton((prev) => !prev); // toggle true/false
  };

  const syncDateRangeParams = (nextStartDate, nextEndDate) => {
    setStartDate(nextStartDate);
    setEndDate(nextEndDate);
    // The user has now explicitly interacted with the shared date range (picked or cleared it)
    // on whichever tab they're on - from this point on it's a real, sticky choice instead of
    // the auto-computed month-to-date default, and useConsoleSearch will persist it as such.
    setHasExplicitDateRange(true);
    setSideBarLinkActive("careConsole");
  };

  const handleDateRangeChange = async (nextStartDate, nextEndDate) => {
    syncDateRangeParams(nextStartDate, nextEndDate);

    // inBoundCalls/leadGTab paginate server-side (SearchWithDatePAuthQ /
    // SearchWithDateLeadGeneration), so just bump a nonce and let the child
    // component's own Load-More-aware fetch run, instead of doing a single
    // unbounded dateRangeRequest fetch here. Bump on clear too (empty dates) -
    // otherwise clearing resets the displayed fields but never refetches.
    if (activeTab === "inBoundCalls") {
      setInBoundFilterNonce((current) => current + 1);
      return;
    }

    if (activeTab === "leadGTab") {
      setLeadGFilterNonce((current) => current + 1);
      return;
    }

    const shouldAutoApplyDateRange = ["chatG", "uatTab", "inboundLogsTab"].includes(
      activeTab,
    );

    if (shouldAutoApplyDateRange) {
      await handleStartDateChange(
        buildDateRangeParams(nextStartDate, nextEndDate),
      );
    }
  };

  // formated date to "YYYY-MM-DD"
  function formatDate(date) {
    const getyear = date.getFullYear();
    const getmonth = String(date.getMonth() + 1).padStart(2, "0");
    const getdate = String(date.getDate()).padStart(2, "0");
    return `${getyear}-${getmonth}-${getdate}`;
  }

  async function getCallsFetchHandle() {
    setUatTestGridData([]);
    let obj = { fromContact: outBoundContact };
    const userData = await dateRangeRequest(token, `/api/getCalls`, obj);
    if (userData == "Token is expired, login again") {
      setIsTokenExpired(true);
    } else if (userData == "no record") {
      setUatTestGridData([]);
    } else {
      setUatTestGridData(userData);
    }
  }

  async function getInboundCallLogsHandle() {
    setInboundCallLogsData([]);
    let obj = { inboundContact };
    const userData = await dateRangeRequest(token, `/api/getInboundCalls`, obj);
    if (userData == "Token is expired, login again") {
      setIsTokenExpired(true);
    } else if (userData == "no record") {
      setInboundCallLogsData([]);
    } else {
      setInboundCallLogsData(userData);
    }
  }

  // const handleDeletePractice = async () => {
  //   // debugger
  //   setLoading(true)
  //   let obj = { practiceId: PracticeId };
  //   let url = `/api/removePractice`;

  //   const userData = await deleteRequest(token, url, obj);
  //   if (userData == "Token is expired, login again") {
  //     setIsTokenExpired(true)
  //     setLoading(false)
  //   }
  //   else if (userData && userData.success == true) {
  //     setShowSuccessMsg(userData.success)
  //     fetchPracticesList(userType);
  //     setLoading(false)
  //   }
  // }

  // Token-expiry redirect is now handled once, centrally, in ContextApi.js - see its comment
  // for why this component's own copy of the same effect was removed.

  // useEffect(() => {
  //   if (PracticeId) {

  //     setSubscription("");
  //   }
  // }, [PracticeId]);

  // const handleAccessTabs = () => {
  //   accessRights.forEach((featureslist) => {
  //     if (featureslist.FeatureId === 1 && featureslist.RightsDetail == '1') {
  //       debugger
  //       setPAuthQTab("")
  //       setActiveTab("")
  //       document.getElementById('pAuthQTabContainer').classList.add("disabledTab");
  //       var nodes = document.getElementById("pAuthQTabContainer").getElementsByTagName('*');
  //       for (var i = 0; i < nodes.length; i++) {
  //         console.log(nodes[i])
  //         nodes[i].disabled = true;
  //       }
  //       tabDisabled = true;

  //       return
  //     }

  //   })
  // }

  // useEffect(() => {
  //   if (accessRights.length > 0) {

  //     handleAccessTabs()
  //   }
  // }, [accessRights]);


  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tab = params.get("tab");
    const savedTab = sessionStorage.getItem("redirectTab");

    if (!token) {
      if (tab === "summary") {
        sessionStorage.setItem("redirectTab", "summary");
      }
      return;
    }

    if (tab === "summary" || savedTab === "summary") {
      showHideSelectedTabControls("summaryTab");
      if (savedTab === "summary") {
        sessionStorage.removeItem("redirectTab");
      }
    }
  }, [token]);

  useEffect(() => {
    registerPhoneTabSetter(setIsPhoneTab);
  }, [registerPhoneTabSetter]);

  useEffect(() => {
    // Gate on PracticeId - userType/rightsEnabled both default to their
    // "no access" values before /api/currentUser resolves, so without this
    // gate a real admin gets bounced back to careConsole on every fresh load.
    if (
      PracticeId &&
      userType === "client" &&
      !orgPageAccessConfigured &&
      rightsEnabled === false &&
      !["support", "tickets", "dialer"].includes(sideBarLinkActive)
    ) {
      setSideBarLinkActive("careConsole");
    }
  }, [
    orgPageAccessConfigured,
    rightsEnabled,
    setSideBarLinkActive,
    sideBarLinkActive,
    userType,
    PracticeId,
  ]);

  useEffect(() => {
    if (
      sideBarLinkActive === "apiIntegration" &&
      activeTab !== "inBoundCalls" &&
      activeTab !== "leadGTab" &&
      activeTab !== "summaryTab"
    ) {
      setSideBarLinkActive("careConsole");
    }
  }, [sideBarLinkActive, activeTab]);

  useEffect(() => {
    setIsPhoneTab(false);
  }, [sideBarLinkActive]);

  useEffect(() => {
    const removedTabs = [
      "pAuthSTab",
      "benefitVTab",
      "careRTab",
      "visitRTab",
      "awareNessCTab",
    ];

    if (removedTabs.includes(activeTab)) {
      showHideSelectedTabControls("inBoundCalls");
    }
  }, [activeTab, PracticeId, token]);

  if (sideBarLinkActive === "support") {
    return <SupportPage />;
  }

  if (sideBarLinkActive === "tickets" && !PracticeId) {
    return (
      <div className="d-flex justify-content-center mt-5 pt-5">
        <div className="spinner-border text-light" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (sideBarLinkActive === "tickets" && PracticeId && !canViewTickets) {
    return null;
  }

  if (sideBarLinkActive === "tickets") {
    return <TicketsPage />;
  }

  if (isPWADialer || sideBarLinkActive === "dialer") {
    return <DialerPage />;
  }

  return (
    <>
      <div
        className={`row home-toolbar d-flex ${userType !== "admin" ? "pt-2" : "mt-2"
          } position-relative`}
      >
        {userType === "admin" ? (
          <>
            <div className="col-lg-5 d-flex">
              <div className="home-org-panel d-flex flex-column w-100">
                <div className="d-flex align-items-center">
                  <span className="home-select-practice">Select Organization</span>
                  <div className="home-org-dropdown" ref={orgMenuRef}>
                    <button
                      type="button"
                      className={`home-org-trigger${isOrgMenuOpen ? " is-open" : ""}`}
                      id="selectedProviderId"
                      aria-haspopup="menu"
                      aria-expanded={isOrgMenuOpen}
                      title={selectedPracticeLabel}
                      onClick={() => setIsOrgMenuOpen((current) => !current)}
                    >
                      <span className="home-org-trigger__label">
                        {selectedPracticeLabel}
                      </span>
                      <span
                        className={`home-org-trigger__chevron${isOrgMenuOpen ? " is-open" : ""}`}
                        aria-hidden="true"
                      >
                        ▾
                      </span>
                    </button>
                    {isOrgMenuOpen ? (
                      <div className="home-org-menu" role="menu">
                        <input
                          type="text"
                          className="home-org-menu__search"
                          placeholder="Search organizations"
                          value={orgSearchQuery}
                          onChange={(e) => setOrgSearchQuery(e.target.value)}
                          onClick={(e) => e.stopPropagation()}
                          autoFocus
                          aria-label="Search organizations"
                        />
                        <div className="home-org-menu__list">
                          {filteredSelectablePractices.length ? (
                            filteredSelectablePractices.map((practice) => {
                              const isSelected =
                                String(practice.Id) === String(PracticeId);

                              return (
                                <button
                                  key={practice.Id}
                                  type="button"
                                  role="menuitemradio"
                                  aria-checked={isSelected}
                                  className={`home-org-menu__item${
                                    isSelected ? " is-selected" : ""
                                  }`}
                                  onClick={() => handlePracticeSelect(practice.Id)}
                                >
                                  {practice.PracticeName}
                                </button>
                              );
                            })
                          ) : (
                            <div className="home-org-menu__empty">No organizations match.</div>
                          )}
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          ""
        )}
        <div
          className={`${
            userType === "admin" ? "col-lg-5" : "col-lg-9"
          } home-toolbar-meta-col`}
        >
          <div
            className={`home-toolbar-meta mt-2 d-flex align-items-center ${userType === "admin" ? "justify-content-end" : "justify-content-start"
              }`}
          />
        </div>
        <div
          className={`${
            userType === "admin" ? "col-lg-2" : "col-lg-3"
          } home-user-slot`}
        >
          <div
            className="dropdown d-flex flex-row-reverse align-items-center home-user-dropdown"
            ref={userMenuRef}
          >
            <button
              className="d-flex align-items-center text-white text-decoration-none dropdown-toggle border-0 bg-transparent p-0 home-user-trigger"
              id="dropdownUser1"
              aria-expanded={isUserMenuOpen}
              type="button"
              onClick={() => setIsUserMenuOpen((current) => !current)}
            >
              <span className="header-user-badge" aria-hidden="true">
                {userBadgeInitial}
              </span>
            </button>
            <ul
              className={`dropdown-menu dropdown-menu-dark text-small shadow user-dropdown-menu ${
                isUserMenuOpen ? "show" : ""
              }`}
            >
              <>
                <li className="user-dropdown-header px-3 py-2">
                  <div className="fw-bold user-dropdown-name" id="userName">
                    {userName}
                  </div>
                  <div className="fw-bold user-dropdown-role" id="userProfestion">
                    {userType === "admin" ? userAdmin : userProfession}
                  </div>
                </li>
                <li>
                  <div className="user-dropdown-org px-3 py-2">
                    <div className="user-dropdown-org-label">Organization</div>
                    <div className="user-dropdown-org-row">
                      <span className="user-dropdown-org-name">
                        {ownPracticeName || "No organization selected"}
                      </span>
                      <button
                        type="button"
                        className="user-dropdown-org-edit"
                        onClick={() => {
                          setIsUserMenuOpen(false);
                          openOrganizationModal();
                        }}
                        aria-label="Edit organization name"
                        title="Edit organization name"
                      >
                        <FontAwesomeIcon icon={faPenToSquare} />
                      </button>
                    </div>
                  </div>
                </li>
                <li>
                  <hr className="dropdown-divider my-1" />
                </li>
                <li>
                  <button
                    className="dropdown-item user-dropdown-link"
                    onClick={openSettingsPanel}
                  >
                    Settings
                  </button>
                </li>
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => {
                      setIsUserMenuOpen(false);
                      tokenExpiryLogoutHandle();
                    }}
                  >
                    Sign out
                  </button>
                </li>
              </>
            </ul>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col" id="contentArea">
          {sideBarLinkActive !== "addUsers" &&
            sideBarLinkActive !== "manageOrg" &&
            sideBarLinkActive !== "dialer" &&
            sideBarLinkActive !== "support" &&
            sideBarLinkActive !== "tickets" ? (
            <>
              <div
                className={`rounded py-3 px-2 kendoContainer bg_dark_opacity ${isRightsLoad ? "home-rights-loading" : ""
                  }`}
                id="memberGridContainer"
              >
                <div className="row tabs custom-overflow-x pb-3 mb-2 inbound-tab-strip">
                  {/* <div id="pAuthQTabContainer" className={`col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 position-relative tab-container`}>
                <div id="pAuthQTab" className={`position-relative rounded-3 ${activeTab === "pAuthQTab" ? "hHubTab_Active" : ""} hHubTab_Container`}
                  onClick={() => showHideSelectedTabControls('pAuthQTab')}>
                  <div className="py-2 ps-2">
                    <a className="btn btn-success btnHealthHubEvent py-2" data-name="Clm">
                      <span className="rounded-3 appointmentType" id="TabValue">
                        P<sub className="auth">auth</sub>Q
                      </span>
                    </a>
                  </div>
                </div>
                <a className="bg_dark color_blue hHUb_Notifications_bell" id="cLMNotification" title="Clm notifications">
                  <FontAwesomeIcon icon={faBell} className="align-middle" />
                  <span className="position-absolute notificationOrange d-none"></span>
                </a>
                <div className="btn-FHIR">
                  <div className="text-end EMR-div">
                    <div className="tab-ankar-link">
                      <a
                        href="#"
                        className="bg_darke EMR-inkar-tag PauthAnkarTag"
                        title="Open FHIR"
                      >
                        EMR
                      </a>
                    </div>
                    <div className="cd-blinking">
                      <div className="dot"></div>
                      <div className="pulse"></div>
                    </div>
                  </div>
                  <div className="text-end EMR-div">
                    <div className="tab-ankar-link">
                      <a
                        href="#"
                        className="bg_darke EMR-inkar-tag PauthAnkarTag"
                        title="Open FHIR"
                      >
                        Schedule
                      </a>
                    </div>
                    <div className="cd-blinking">
                      <div className="dot"></div>
                      <div className="pulse"></div>
                    </div>
                  </div>
                </div>
                <img
                  src={TabPointer_icon}
                  className="hHubTabsAfterIcon"
                  alt="Tab Pointer"
                />
              </div> */}
                  <div
                    id="inBoundCallsContainer"
                    className={`col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 position-relative tab-container`}
                  >
                    <div
                      id="inBoundCalls"
                      className={`position-relative rounded-3 ${activeTab === "inBoundCalls" ? "hHubTab_Active" : ""
                        } hHubTab_Container`}
                      onClick={() =>
                        showHideSelectedTabControls("inBoundCalls")
                      }
                    >
                      <div className="py-2 ps-2">
                        <a
                          className="btn btn-success btnHealthHubEvent py-2"
                          data-name="Clm"
                        >
                          <span
                            className="rounded-3 appointmentType home-inbound-tab-label"
                            id="TabValue"
                          >
                            {/* IB<sub>Call</sub>S */}
                            In<sub>boun</sub>d
                          </span>
                        </a>
                      </div>
                    </div>
                    {/* <a
                  className="bg_dark color_blue hHUb_Notifications_bell"
                  id="cLMNotification"
                  title="Clm notifications"
                >
                  <FontAwesomeIcon icon={faBell} className="align-middle" />
                  <span className="position-absolute notificationOrange d-none"></span>
                </a>
                <div className="btn-FHIR">
                  <div className="text-end EMR-div">
                    <div className="tab-ankar-link">
                      <a
                        href="#"
                        className="bg_darke EMR-inkar-tag PauthAnkarTag"
                        title="Open FHIR"
                      >
                        EMR
                      </a>
                    </div>
                    <div className="cd-blinking">
                      <div className="dot"></div>
                      <div className="pulse"></div>
                    </div>
                  </div>
                  <div className="text-end EMR-div">
                    <div className="tab-ankar-link">
                      <a
                        href="#"
                        className="bg_darke EMR-inkar-tag PauthAnkarTag"
                        title="Open FHIR"
                      >
                        Schedule
                      </a>
                    </div>
                    <div className="cd-blinking">
                      <div className="dot"></div>
                      <div className="pulse"></div>
                    </div>
                  </div>
                </div> */}
                    <img
                      src={TabPointer_icon}
                      className="hHubTabsAfterIcon"
                      alt="Tab Pointer"
                    />
                  </div>
                  <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 position-relative tab-container">
                    <div
                      className={`position-relative rounded-3 hHubTab_Container ${activeTab === "leadGTab" ? "hHubTab_Active" : ""
                        } `}
                      id="leadGTab"
                      onClick={() => showHideSelectedTabControls("leadGTab")}
                    >
                      <div className="py-2 ps-2">
                        <a
                          href="#"
                          className="btn btn-danger btnHealthHubEvent py-2"
                          data-name="EMR"
                        >
                          <span
                            className="rounded-3 appointmentType"
                            id="leadTabHeading"
                          >
                            L<sub>ead</sub>G
                          </span>
                        </a>
                      </div>
                    </div>
                    {/* <a
                  className="bg_dark color_blue hHUb_Notifications_bell"
                  id="eRMNotification"
                  title="EMR notifications"
                >
                  <FontAwesomeIcon icon={faBell} className="align-middle" />
                  <span className="position-absolute notificationOrange d-none"></span>
                </a>
                <div className="btn-FHIR">
                  <div className="text-end EMR-div">
                    <div className="tab-ankar-link">
                      <a
                        href="#"
                        className="bg_darke EMR-inkar-tag PauthAnkarTag"
                        title="Open FHIR"
                      >
                        Schedule
                      </a>
                    </div>
                    <div className="cd-blinking">
                      <div className="dot"></div>
                      <div className="pulse"></div>
                    </div>
                  </div>
                </div>*/}
                    <img
                      src={TabPointer_icon}
                      className="hHubTabsAfterIcon"
                      alt="Tab Pointer"
                    />
                  </div>
                  {/* <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 position-relative tab-container">
                <div
                  className={`position-relative rounded-3 hHubTab_Container ${activeTab === "surveyTab" ? "hHubTab_Active" : ""} `}
                  id="surveyTab"
                  onClick={() => showHideSelectedTabControls("surveyTab")}
                >
                  <div className="py-2 ps-2">
                    <a href="#" className="btn btn-secondary btnHealthHubEvent py-2" data-name="EMR"
                    >
                      <span
                        className="rounded-3 appointmentType"
                        id="refTabHeading"
                      >
                        S<sub>urve</sub>y
                      </span>
                    </a>
                  </div>
                </div>
                <a
                  className="bg_dark color_blue hHUb_Notifications_bell"
                  id="eRMNotification"
                  title="EMR notifications"
                >
                  <FontAwesomeIcon icon={faBell} className="align-middle" />
                  <span className="position-absolute notificationOrange d-none"></span>
                </a>
                <div className="btn-FHIR">
                  <div className="text-end EMR-div">
                    <div className="tab-ankar-link">
                      <a
                        href="#"
                        className="bg_darke EMR-inkar-tag PauthAnkarTag"
                        title="Open FHIR"
                      >
                        Schedule
                      </a>
                    </div>
                    <div className="cd-blinking">
                      <div className="dot"></div>
                      <div className="pulse"></div>
                    </div>
                  </div>
                </div>
                <img
                  src={TabPointer_icon}
                  className="hHubTabsAfterIcon"
                  alt="Tab Pointer"
                />
              </div> */}

                  {/* CHATbot G */}

                  <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 position-relative tab-container">
                    <div
                      className={`position-relative rounded-3 hHubTab_Container ${activeTab === "chatG" ? "hHubTab_Active" : ""
                        } `}
                      id="chatG"
                      onClick={() => {
                        showHideSelectedTabControls("chatG");
                      }}
                    >
                      <div className="py-2 ps-2">
                        <a
                          href="#"
                          className="btn btn-light btnHealthHubEvent py-2"
                          data-name="Raf"
                        >
                          <span
                            className="rounded-3 appointmentType"
                            id="chatTabHeading"
                          >
                            C<sub>hat</sub>G
                          </span>
                        </a>
                      </div>
                    </div>
                    <div className="btn-FHIR">
                      <div className="text-end EMR-div">
                        {/* <div className="tab-ankar-link"> */}
                        <a
                          href={`https://chat.allyzent.com/${practiceContactNumber}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) =>
                            e.preventDefault() ||
                            window.open(
                              `https://chat.allyzent.com/${practiceContactNumber}`,
                              "_blank",
                              "noopener,noreferrer"
                            )
                          }
                          className="bg_darke EMR-inkar-tag PauthAnkarTag"
                          id="chatGAccess"
                        >
                          <FontAwesomeIcon
                            icon={faArrowUpRightFromSquare}
                            className="fa-launch"
                          />
                          <span>launch</span>
                        </a>
                      </div>
                      {/* </div> */}
                    </div>
                    {/* <a
                  className="bg_dark  color_blue hHUb_Notifications_bell"
                  id="rAfNotification"
                  title="Raf notifications"
                >
                  <FontAwesomeIcon icon={faBell} className="align-middle" />
                  <span className="position-absolute notificationOrange d-none"></span>
                </a>
                <div className="btn-FHIR">
                  <div className="text-end EMR-div">
                    <div className="tab-ankar-link">
                      <a
                        href="#"
                        className="bg_darke EMR-inkar-tag PauthAnkarTag"
                        title="Open FHIR"
                      >
                        EMR
                      </a>
                    </div>
                    <div className="cd-blinking">
                      <div className="dot"></div>
                      <div className="pulse"></div>
                    </div>
                  </div>
                  <div className="text-end EMR-div">
                    <div className="tab-ankar-link">
                      <a
                        href="#"
                        className="bg_darke EMR-inkar-tag PauthAnkarTag"
                        title="Open FHIR"
                      >
                        Schedule
                      </a>
                    </div>
                    <div className="cd-blinking">
                      <div className="dot"></div>
                      <div className="pulse"></div>
                    </div>
                  </div>
                </div> */}
                    <img
                      src={TabPointer_icon}
                      className="hHubTabsAfterIcon"
                      alt="Tab Pointer"
                    />
                  </div>

                  {/* SMS Tab (hidden temporarily)
                  <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 position-relative tab-container">
                    <div
                      className={`position-relative rounded-3 hHubTab_Container ${activeTab === "smsTab" ? "hHubTab_Active" : ""
                        } `}
                      id="smsTab"
                      onClick={() => {
                        showHideSelectedTabControls("smsTab");
                      }}
                    >
                      <div className="py-2 ps-2">
                        <a
                          href="#"
                          className="btn btn-light btnHealthHubEvent py-2"
                          data-name="SMS"
                        >
                          <span
                            className="rounded-3 appointmentType"
                            id="smsTabHeading"
                          >
                            SMS
                          </span>
                        </a>
                      </div>
                    </div>
                    <img
                      src={TabPointer_icon}
                      className="hHubTabsAfterIcon"
                      alt="Tab Pointer"
                    />
                  </div>
                  */}

                  {/* Summary Tab */}
                  <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 position-relative tab-container">
                    <div
                      className={`position-relative rounded-3 hHubTab_Container summaryTabBox ${activeTab === "summaryTab" ? "hHubTab_Active" : ""
                        } `}
                      id="summaryTab"
                      onClick={() => {
                        showHideSelectedTabControls("summaryTab");
                      }}
                    >
                      <div className="py-2 ps-2">
                        <a
                          href="#"
                          className="btn btn-light btnHealthHubEvent py-2"
                          data-name="Summary"
                        >
                          <span
                            className="rounded-3 appointmentType"
                            id="summaryTabHeading"
                          >
                            Summary
                          </span>
                        </a>
                      </div>
                    </div>
                    <img
                      src={TabPointer_icon}
                      className="hHubTabsAfterIcon"
                      alt="Tab Pointer"
                    />
                  </div>

                  {showLogButton && (
                    <>
                      <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 position-relative tab-container">
                        <div
                          className={`position-relative rounded-3 hHubTab_Container ${activeTab === "uatTab" ? "hHubTab_Active" : ""
                            } `}
                          id="uatTab"
                          onClick={() => showHideSelectedTabControls("uatTab")}
                        >
                          <div className="py-2 ps-2">
                            <a
                              href="#"
                              className="btn btn-secondary btnHealthHubEvent py-2"
                              data-name="EMR"
                            >
                              <span
                                style={{ lineHeight: "1.1" }}
                                className="rounded-3 appointmentType"
                                id="refTabHeading"
                              >
                                O<sub>utbn</sub>d
                                <br />
                                <sub>logs</sub>
                                {/* O<sub>outboun</sub>d */}
                                {/* UAT<br/>Test */}
                              </span>
                            </a>
                          </div>
                        </div>
                        {/* <a
                  className="bg_dark color_blue hHUb_Notifications_bell"
                  id="eRMNotification"
                  title="EMR notifications"
                >
                  <FontAwesomeIcon icon={faBell} className="align-middle" />
                  <span className="position-absolute notificationOrange d-none"></span>
                </a>
                <div className="btn-FHIR">
                  <div className="text-end EMR-div">
                    <div className="tab-ankar-link">
                      <a
                        href="#"
                        className="bg_darke EMR-inkar-tag PauthAnkarTag"
                        title="Open FHIR"
                      >
                        Schedule
                      </a>
                    </div>
                    <div className="cd-blinking">
                      <div className="dot"></div>
                      <div className="pulse"></div>
                    </div>
                  </div>
                </div> */}
                        <img
                          src={TabPointer_icon}
                          className="hHubTabsAfterIcon"
                          alt="Tab Pointer"
                        />
                      </div>

                      {/* Inbound Call logs tab */}
                      <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 position-relative tab-container">
                        <div
                          className={`position-relative rounded-3 hHubTab_Container ${activeTab === "inboundLogsTab"
                            ? "hHubTab_Active"
                            : ""
                            } `}
                          id="inboundLogsTab"
                          onClick={() =>
                            showHideSelectedTabControls("inboundLogsTab")
                          }
                        >
                          <div className="py-2 ps-2">
                            <a
                              href="#"
                              className="btn btn-secondary btnHealthHubEvent py-2"
                              data-name="EMR"
                            >
                              <span
                                style={{ lineHeight: "1.1" }}
                                className="rounded-3 appointmentType"
                                id="refTabHeading"
                              >
                                I<sub>nboun</sub>d
                                <br />
                                <sub>logs</sub>
                                {/* O<sub>outboun</sub>d */}
                                {/* UAT<br/>Test */}
                              </span>
                            </a>
                          </div>
                        </div>
                        {/* <a
                      className="bg_dark color_blue hHUb_Notifications_bell"
                      id="eRMNotification"
                      title="EMR notifications"
                    >
                      <FontAwesomeIcon icon={faBell} className="align-middle" />
                      <span className="position-absolute notificationOrange d-none"></span>
                    </a>
                    <div className="btn-FHIR">
                      <div className="text-end EMR-div">
                        <div className="tab-ankar-link">
                          <a
                            href="#"
                            className="bg_darke EMR-inkar-tag PauthAnkarTag"
                            title="Open FHIR"
                          >
                            Schedule
                          </a>
                        </div>
                        <div className="cd-blinking">
                          <div className="dot"></div>
                          <div className="pulse"></div>
                        </div>
                      </div>
                    </div> */}
                        <img
                          src={TabPointer_icon}
                          className="hHubTabsAfterIcon"
                          alt="Tab Pointer"
                        />
                      </div>
                    </>
                  )}
                </div>
                {isRightsLoad ? (
                  <div className="d-flex justify-content-center mt-5 pt-5">
                    <div className="spinner-border text-light" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : sideBarLinkActive === "careConsole" ? (
                  <div className="row">
                    {
                      // activeTab === "pAuthQTab" ?
                      //   <PauThQGrid setIsCallsDataGet={setIsCallsDataGet} isCallsDataGet={isCallsDataGet} setPriorAuthQGridData={setPriorAuthQGridData} priorAuthQGridData={priorAuthQGridData} setIsUploadLead={setIsUploadLead} isUploadLead={isUploadLead} providerName={providerName} patientName={patientName} startDate={startDate} endDate={endDate} /> :
                      activeTab === "inBoundCalls" ? (
                        <div className="col-12 inbound-workspace">
                          <InboundOverview
                            practiceContactNumber={practiceContactNumber}
                            inboundContact={inboundContact}
                            inBoundsCalls={inBoundsCalls}
                            startDate={startDate}
                            endDate={endDate}
                          />
                          <div className="inbound-call-table-shell">
                            <InBoundCalls
                              setIsCallsDataGet={setIsCallsDataGet}
                              isCallsDataGet={isCallsDataGet}
                              setInBoundsCalls={setInBoundsCalls}
                              inBoundsCalls={inBoundsCalls}
                              setIsUploadLead={setIsUploadLead}
                              isUploadLead={isUploadLead}
                              providerName={providerName}
                              patientName={patientName}
                              startDate={startDate}
                              endDate={endDate}
                              filterNonce={inBoundFilterNonce}
                              tableTopBarControls={
                                <div className="inbound-call-table-range">
                                  <DateRangePicker
                                    startDate={startDate}
                                    endDate={endDate}
                                    onRangeChange={handleDateRangeChange}
                                    disabled={!canUseDateInputs}
                                  />
                                </div>
                              }
                            />
                          </div>
                        </div>
                      ) : activeTab === "chatG" ? (
                        <ChatGGrid
                          setOutBoundLeadsDetail={setOutBoundLeadsDetail}
                          setIsCallsDataGet={setIsCallsDataGet}
                          isCallsDataGet={isCallsDataGet}
                          setChatGGridData={setChatGGridData}
                          chatGGridData={chatGGridData}
                          setIsUploadLead={setIsUploadLead}
                          isUploadLead={isUploadLead}
                          providerName={providerName}
                          patientName={patientName}
                          startDate={startDate}
                          endDate={endDate}
                        />
                   
                      ) : activeTab === "summaryTab" ? (
                        <InboundCallSummary
                          startDate={startDate}
                          endDate={endDate}
                          hasExplicitDateRange={hasExplicitDateRange}
                          onRangeChange={handleDateRangeChange}
                        />
                      ) : activeTab === "smsTab" ? (
                        null
                      ) : activeTab === "leadGTab" ? (
                        <div className="col-12 inbound-workspace">
                          <OutboundOverview
                            practiceContactNumber={practiceContactNumber}
                            outboundContact={outBoundContact}
                            leads={leadGGridData}
                            startDate={startDate}
                            endDate={endDate}
                          />
                          <div className="inbound-call-table-shell">
                            <LeadGGrid
                              setOutBoundLeadsDetail={setOutBoundLeadsDetail}
                              setIsCallsDataGet={setIsCallsDataGet}
                              isCallsDataGet={isCallsDataGet}
                              setLeadGGridData={setLeadGGridData}
                              leadGGridData={leadGGridData}
                              setIsUploadLead={setIsUploadLead}
                              isUploadLead={isUploadLead}
                              providerName={providerName}
                              patientName={patientName}
                              startDate={startDate}
                              endDate={endDate}
                              filterNonce={leadGFilterNonce}
                              tableTopBarControls={
                                <div className="inbound-call-table-range">
                                  <DateRangePicker
                                    startDate={startDate}
                                    endDate={endDate}
                                    onRangeChange={handleDateRangeChange}
                                    disabled={!canUseDateInputs}
                                  />
                                </div>
                              }
                            />
                          </div>
                        </div>
                      ) : activeTab === "uatTab" ? (
                        <UAT_Test
                          formatDate={formatDate}
                          setIsDataGetWithDate={setIsDataGetWithDate}
                          isDataGetWithDate={isDataGetWithDate}
                          setIsCallsDataGet={setIsCallsDataGet}
                          isCallsDataGet={isCallsDataGet}
                          setUatTestGridData={setUatTestGridData}
                          uatTestGridData={uatTestGridData}
                          setIsDatesEmpty={setIsDatesEmpty}
                          isDatesEmpty={isDatesEmpty}
                          startDate={startDate}
                          endDate={endDate}
                        />
                      ) : (
                        <InboundCallLogs
                          formatDate={formatDate}
                          setIsDataGetWithDateInbound={
                            setIsDataGetWithDateInbound
                          }
                          isDataGetWithDateInbound={isDataGetWithDateInbound}
                          setIsCallsDataGet={setIsCallsDataGet}
                          isCallsDataGet={isCallsDataGet}
                          setInboundCallLogsData={setInboundCallLogsData}
                          inboundCallLogsData={inboundCallLogsData}
                          setIsDatesEmpty={setIsDatesEmpty}
                          isDatesEmpty={isDatesEmpty}
                          startDate={startDate}
                          endDate={endDate}
                        />
                      )
                    }
                  </div>
                ) : sideBarLinkActive === "bulkUpload" ? (
                  <div className="row">
                    <button
                      type="button"
                      className="btn btn-link ps-3 mb-2 text-decoration-none d-inline-flex align-items-center gap-2"
                      onClick={() =>
                        navigate(activeTab === "leadGTab" ? "/outbound" : "/inbound")
                      }
                    >
                      <FontAwesomeIcon icon={faArrowLeft} />
                      Back
                    </button>
                    {activeTab === "leadGTab" ? (
                      <ManageLeadsPage
                        outBoundLeadsDetail={outBoundLeadsDetail}
                        setOutBoundLeadsDetail={setOutBoundLeadsDetail}
                      />
                    ) : (
                      <BulkUploadLead
                        outBoundLeadsDetail={outBoundLeadsDetail}
                        setOutBoundLeadsDetail={setOutBoundLeadsDetail}
                        setIsBulkUploaded={setIsBulkUploaded}
                        isBulkUploaded={isBulkUploaded}
                      />
                    )}
                  </div>
                ) : sideBarLinkActive === "callSettings" ? (
                  <div className="row">
                    <GeneralCallSetting />
                  </div>
                ) : sideBarLinkActive === "summaryPromptHub" ? (
                  <div className="row">
                    <div className="col-12">
                      <SummaryPromptHub
                        onBack={() => {
                          setSideBarLinkActive("careConsole");
                          setActiveTab("summaryTab");
                          navigate("/summary");
                        }}
                        onOpenWorkspace={(tabId) => {
                          showHideSelectedTabControls(tabId);
                          setSideBarLinkActive("onBoardingForm");
                          const promptHubWorkflowByTab = {
                            inBoundCalls: "inbound",
                            leadGTab: "outbound",
                            chatG: "chatg",
                          };
                          navigate(`/prompt-hub/${promptHubWorkflowByTab[tabId] || "inbound"}`);
                        }}
                      />
                    </div>
                  </div>
                ) : // : sideBarLinkActive === "onBoardingForm" && isRightsLoad ?
                  //   <div className="d-flex justify-content-center mt-5 pt-5">
                  //     <div className="spinner-border text-light" role="status">
                  //       <span className="visually-hidden">Loading...</span>
                  //     </div>
                  //   </div>
                  sideBarLinkActive === "onBoardingForm" && !isRightsLoad ? (
                    <div className="row">
                      {
                        // activeTab === "inBoundCalls" ?
                        //   <InBoundCalls  setIsCallsDataGet={setIsCallsDataGet} isCallsDataGet={isCallsDataGet} setInBoundsCalls={setInBoundsCalls} inBoundsCalls={inBoundsCalls} setIsUploadLead={setIsUploadLead} isUploadLead={isUploadLead} providerName={providerName} patientName={patientName} startDate={startDate} endDate={endDate} /> :
                        userType === "client" && rightsEnabled === false ? (
                          ""
                        ) : (userType === "admin" &&
                          activeTab === "inBoundCalls") ||
                          (userType === "client" &&
                            rightsEnabled === true &&
                            activeTab === "inBoundCalls") ? (
                          <PAuthQOnBoardingForm
                            setIsUploadLead={setIsUploadLead}
                          />
                        ) : (userType === "admin" && activeTab === "chatG") ||
                          (userType === "client" &&
                            rightsEnabled === true &&
                            activeTab === "chatG") ? (
                          <ChatGOnBoardingForm />
                        ) : (userType === "admin" && activeTab === "leadGTab") ||
                          (userType === "client" &&
                            rightsEnabled === true &&
                            activeTab === "leadGTab") ? (
                          <LeadGenerationOnboardingForm />
                        ) : activeTab === "summaryTab" ? (
                          <SummaryPromptHub
                            onBack={() => {
                              setSideBarLinkActive("careConsole");
                              setActiveTab("summaryTab");
                              navigate("/summary");
                            }}
                            onOpenWorkspace={(tabId) => {
                              showHideSelectedTabControls(tabId);
                              setSideBarLinkActive("onBoardingForm");
                            }}
                          />
                        ) : activeTab === "uatTab" ? (
                          <UAT_Test
                            setIsDataGetWithDate={setIsDataGetWithDate}
                            isDataGetWithDate={isDataGetWithDate}
                            setIsCallsDataGet={setIsCallsDataGet}
                            isCallsDataGet={isCallsDataGet}
                            setUatTestGridData={setUatTestGridData}
                            uatTestGridData={uatTestGridData}
                            setIsDatesEmpty={setIsDatesEmpty}
                            isDatesEmpty={isDatesEmpty}
                            startDate={startDate}
                            endDate={endDate}
                          />
                        ) : (
                          <InboundCallLogs
                            formatDate={formatDate}
                            setIsDataGetWithDateInbound={
                              setIsDataGetWithDateInbound
                            }
                            isDataGetWithDateInbound={isDataGetWithDateInbound}
                            setIsCallsDataGet={setIsCallsDataGet}
                            isCallsDataGet={isCallsDataGet}
                            setInboundCallLogsData={setInboundCallLogsData}
                            inboundCallLogsData={inboundCallLogsData}
                            setIsDatesEmpty={setIsDatesEmpty}
                            isDatesEmpty={isDatesEmpty}
                            startDate={startDate}
                            endDate={endDate}
                          />
                        )
                      }
                    </div>
                  ) : sideBarLinkActive === "apiIntegration" ? (
                    <div className="row">
                      {(activeTab == "inBoundCalls" ||
                        activeTab == "leadGTab" ||
                        activeTab == "summaryTab") && <ApiIntegration />}
                    </div>
                  ) : (
                    ""
                  )}
              </div>
            </>
          ) : (
            <>
              {sideBarLinkActive === "addUsers" && userType === "admin" && <AddUsersToOrg />}
              {sideBarLinkActive === "manageOrg" && userType === "admin" && (
                <ManageOrg
                  showLogButton={showLogButton}
                  onToggleShowLogs={toggleShowLogButton}
                  onOpenInboundLogs={() => {
                    setShowLogButton(true);
                    showHideSelectedTabControls("inboundLogsTab");
                  }}
                  onOpenOutboundLogs={() => {
                    setShowLogButton(true);
                    showHideSelectedTabControls("uatTab");
                  }}
                />
              )}
              {sideBarLinkActive === "dialer" && <DialerPage />}
              {sideBarLinkActive === "support" && <SupportPage />}
              {sideBarLinkActive === "tickets" && <TicketsPage />}
            </>
          )}
        </div>
      </div>
      <Modal
        show={showOrganizationModal}
        onHide={() => {
          if (!isSavingOrganizationName) {
            setShowOrganizationModal(false);
            setOrganizationUpdateError("");
          }
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Rename Organization</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label className="form-label mb-2" htmlFor="organizationNameInput">
            Organization Name
          </label>
          <input
            id="organizationNameInput"
            type="text"
            className="form-control"
            value={organizationDraftName}
            onChange={(event) => {
              setOrganizationDraftName(event.target.value);
              setOrganizationUpdateError("");
            }}
            maxLength={120}
            autoFocus
          />
          {organizationUpdateError ? (
            <div className="text-danger mt-2" style={{ fontSize: "0.9rem" }}>
              {organizationUpdateError}
            </div>
          ) : null}
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-outline-secondary"
            type="button"
            onClick={() => {
              setShowOrganizationModal(false);
              setOrganizationUpdateError("");
            }}
            disabled={isSavingOrganizationName}
          >
            Cancel
          </button>
          <button
            className="simple-btn"
            type="button"
            onClick={handleOrganizationRename}
            disabled={isSavingOrganizationName}
          >
            {isSavingOrganizationName ? "Saving..." : "Save"}
          </button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={isSettingsModalOpen}
        onHide={closeSettingsPanel}
        centered
        dialogClassName="user-settings-modal"
      >
        <Modal.Body className="user-settings-modal__body">
          <div className="user-settings-panel user-settings-panel--split">
            <div className="user-settings-header">
              <div>
                <span className="user-settings-panel__eyebrow">
                  Settings
                </span>
                <h3>{userName || "User"}</h3>
              </div>
              <button
                type="button"
                className="user-settings-close"
                onClick={closeSettingsPanel}
                aria-label="Close settings dialog"
              >
                <FontAwesomeIcon icon={faCircleXmark} />
              </button>
            </div>

            <div className="user-settings-split-body">
              <nav className="user-settings-nav">
                {[
                  { key: "profile", label: "Profile" },
                  { key: "phoneNumbers", label: "Phone Numbers" },
                  { key: "timezone", label: "Timezone" },
                ].map((section) => (
                  <button
                    key={section.key}
                    type="button"
                    className={`user-settings-nav-item${activeSettingsSection === section.key ? " is-active" : ""}`}
                    onClick={() => setActiveSettingsSection(section.key)}
                  >
                    {section.label}
                  </button>
                ))}
              </nav>

              <div className="user-settings-content">
                {activeSettingsSection === "profile" ? (
                  <div className="user-settings-section-card">
                    <span className="user-settings-section-card__label">
                      Profile
                    </span>
                    <div className="user-settings-detail-list">
                      <div className="user-settings-detail-row">
                        <span>Name</span>
                        <strong>{userName || "Not available"}</strong>
                      </div>
                      <div className="user-settings-detail-row">
                        <span>Title</span>
                        <strong>
                          {userType === "admin"
                            ? userAdmin
                            : userProfession || "Not available"}
                        </strong>
                      </div>
                      <div className="user-settings-detail-row">
                        <span>Email ID</span>
                        <strong>{userEmail || "Not available"}</strong>
                      </div>
                    </div>
                  </div>
                ) : null}

                {activeSettingsSection === "phoneNumbers" ? (
                  <div className="user-settings-section-card">
                    <div className="user-settings-section-card__header">
                      <span className="user-settings-section-card__label">
                        Phone Numbers
                      </span>
                      <button
                        type="button"
                        className="simple-btn user-settings-panel__action"
                        onClick={() => {
                          closeSettingsPanel();
                          setIsPhoneTab(true);
                        }}
                      >
                        Phone Number Settings
                      </button>
                    </div>
                    <div className="user-settings-detail-list">
                      <div className="user-settings-detail-row">
                        <span>Inbound</span>
                        <strong>{inboundContact || "Not available"}</strong>
                      </div>
                      <div className="user-settings-detail-row">
                        <span>Outbound</span>
                        <strong>{outBoundContact || "Not available"}</strong>
                      </div>
                      <div className="user-settings-detail-row">
                        <span>Practice</span>
                        <strong>{practiceContactNumber || "Not available"}</strong>
                      </div>
                    </div>
                  </div>
                ) : null}

                {activeSettingsSection === "timezone" ? (
                  <div className="user-settings-section-card">
                    <span className="user-settings-section-card__label">
                      Timezone
                    </span>
                    <div className="user-settings-timezone-mode">
                      <label className="user-settings-timezone-mode__option">
                        <input
                          type="radio"
                          name="timezoneSyncMode"
                          checked={timezoneSyncMode === "auto"}
                          onChange={() => handleTimezoneSyncModeChange("auto")}
                        />
                        <span>Auto</span>
                        <InfoTooltip text="Resets to this device's local time at every login" />
                      </label>
                      <label className="user-settings-timezone-mode__option">
                        <input
                          type="radio"
                          name="timezoneSyncMode"
                          checked={timezoneSyncMode === "fixed"}
                          onChange={() => handleTimezoneSyncModeChange("fixed")}
                        />
                        <span>Fixed</span>
                        <InfoTooltip text="Stays on the selected timezone until changed" />
                      </label>
                    </div>
                    <TimeZoneDropdown
                      isBgBlack={false}
                      selectedTimezone={preferredTimezone}
                      onChange={handlePreferredTimezoneChange}
                    />
                    <p className="user-settings-panel__hint">
                      {timezoneSyncMode === "auto"
                        ? "You're in Auto mode - your device's local time is used, and resets at every login. Click Save to apply."
                        : "You're in Fixed mode - the zone you pick stays selected until you change it or switch to Auto. Click Save to apply."}
                    </p>
                    <button
                      type="button"
                      className="simple-btn user-settings-panel__action"
                      disabled={savingPreferredTimezone}
                      onClick={handleSaveTimezone}
                    >
                      {savingPreferredTimezone ? "Saving..." : "Save"}
                    </button>
                    {!savingPreferredTimezone && preferredTimezoneSavedMessage ? (
                      <small className="user-settings-panel__hint">
                        {preferredTimezoneSavedMessage}
                      </small>
                    ) : null}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={isPhoneTab}
        onHide={() => setIsPhoneTab(false)}
        centered
        dialogClassName="phone-settings-modal"
      >
        <Modal.Body className="phone-settings-modal__body">
          <div className="phone-settings-modal__header">
            <div className="phone-settings-modal__title-group">
              <button
                type="button"
                className="phone-settings-modal__back"
                onClick={() => {
                  setIsPhoneTab(false);
                  openSettingsPanel();
                }}
                aria-label="Back to settings"
                title="Back to settings"
              >
                <FontAwesomeIcon icon={faArrowLeft} />
              </button>
              <div>
                <span className="user-settings-panel__eyebrow">
                  Contact Routing
                </span>
                <h3 className="phone-settings-modal__title">Phone Number Settings</h3>
              </div>
            </div>
            <button
              type="button"
              className="user-settings-close"
              onClick={() => setIsPhoneTab(false)}
              aria-label="Close phone number settings dialog"
            >
              <FontAwesomeIcon icon={faCircleXmark} />
            </button>
          </div>
          <PhoneNum
            isDialog
            setIsPhoneTab={setIsPhoneTab}
            setIsTokenExpired={setIsTokenExpired}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

